module.exports = __webpack_public_path__ + "img/remove.e31a6a93.svg";